module.exports = __webpack_public_path__ + "img/pic-6.6afd0144.png";